/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { useFormik } from 'formik';

import { useSnackbar } from 'notistack';
import PartnerForm from '../../components/partnermng/PartnerForm';
import client from '../../lib/api/client';
import { useDispatch, useSelector } from 'react-redux';
import { setPartner } from '../../modules/partnerModule/partner';

const PartnerFormContainer = ({ type, onSaveSuccess }) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { partner } = useSelector(({ partnerModule }) => ({
    partner: partnerModule.partner.partner,
  }));

  let initialValues = {
    partnerTyp:
      partner && partner.partnerTyp !== null ? partner.partnerTyp : '',
    partnerCd:
      partner && partner.partnerCd !== null ? partner.partnerCd : '',
      
    incTyp: partner && partner.incTyp !== null ? partner.incTyp : '',
    tradeTyp:  partner && typeof partner.tradeTyp === 'string'
    ? partner.tradeTyp.split(',').map(s => s.trim())
    : [],
    partnerNm: partner && partner.partnerNm !== null ? partner.partnerNm : '',
    loanAmt: partner && partner.loanAmt !== null ? partner.loanAmt : '0',
    regNumber: partner && partner.regNumber !== null ? partner.regNumber : '',
    partnerPhone:
      partner && partner.partnerPhone !== null ? partner.partnerPhone : '',
    partnerAddr:
      partner && partner.partnerAddr !== null ? partner.partnerAddr : '',
    partnerDesc:
      partner && partner.partnerDesc !== null ? partner.partnerDesc : '',
  };

  const validationSchema = yup.object({
    partnerTyp: yup.string().required('거래처 종류를 선택하세요'),
    partnerCd: yup.string().nullable(),
    incTyp: yup.string().required('산업체 유형을 선택하세요'),
    partnerNm: yup.string('').required('고객명을 입력하세요'),
    loanAmt: yup.string('').required('여신한도를 입력하세요'),
    regNumber: yup
      .string()
      .required('사업자번호를 입력하세요')
      .min(12, '사업자번호를 확인하세요')
      .max(12, '사업자번호를 확인하세요'),
    partnerPhone: yup.string().required('연락처를 입력하세요'),
    partnerAddr: yup.string('').required('주소를 입력하세요'),
    partnerDesc: yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(type, values);
      formik.resetForm();
      setSubmitting(false);
    },
  });

  const onSave = (type, values) => {
    let dataToSubmit = {
      partnerTyp: values.partnerTyp,
      incTyp: values.incTyp,
      partnerNm: values.partnerNm.trim(),
      loanAmt: values.loanAmt || 0,
      regNumber: values.regNumber,
      tradeTyp: values.tradeTyp?.join(',') || '',
      partnerPhone: values.partnerPhone,
      partnerAddr: values.partnerAddr,
      partnerDesc: values.partnerDesc,
    };
    if (type !== 'add') {
      dataToSubmit.partnerCd = values.partnerCd;
    }
    if (type === 'add') {
      client
        .post(`/api/v1/master/partner/info`, dataToSubmit)
        .then((res) => {
          if (res.data.result === 'success') {
            enqueueSnackbar('거래처가 추가되었습니다', {
              variant: 'success',
            });
            // 콜백으로 partnerUuid 전달 (담당자 등록 단계로 이동)
            if (onSaveSuccess) {
              onSaveSuccess(res.data?.info?.partnerUuid);
            } else {
              navigate(`/partnermng/${res.data?.info?.partnerUuid}`);
            }
          } else {
            enqueueSnackbar(res.data?.message, {
              variant: 'error',
            });
          }
        })
        .catch((err) => {
          let message =
            typeof err.response !== 'undefined'
              ? err.response.data.message
              : err.message;
          enqueueSnackbar(message, {
            variant: 'error',
          });
        });
    } else {
      dataToSubmit.partnerUuid = partner.partnerUuid;

      client
        .put(`/api/v1/master/partner/info/${partner.partnerUuid}`, dataToSubmit)
        .then((res) => {
          dispatch(setPartner(res.data.info));
          enqueueSnackbar('거래처가 수정되었습니다', {
            variant: 'success',
          });
        })
        .catch((err) => {
          let message =
            typeof err.response !== 'undefined'
              ? err.response.data.message
              : err.message;
          enqueueSnackbar(message, {
            variant: 'error',
          });
        });
    }
  };

  return <PartnerForm formik={formik} type={type} />;
};

export default PartnerFormContainer;
